import { render, staticRenderFns } from "./config_quota.vue?vue&type=template&id=628836eb&scoped=true"
import script from "./config_quota.vue?vue&type=script&lang=js"
export * from "./config_quota.vue?vue&type=script&lang=js"
import style0 from "./config_quota.vue?vue&type=style&index=0&id=628836eb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628836eb",
  null
  
)

export default component.exports